import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import sweepPreview from "./melbourneCupSweep/sweep-preview.svg";

export interface CompetitionDefinition {
  name: string;
  title: string;
  createdAt: string;
  description: string;
  image: string;
  tags: string[];
  component: LazyExoticComponent<ComponentType>;
}

export const competitionDefinitions: CompetitionDefinition[] = [
  {
    name: "melbourne-cup-sweep",
    title: "Melbourne Cup Sweep",
    createdAt: "2026-10-31",
    description:
      "Bring your group together, draw a horse at random, and see who luck favours on race day.",
    image: sweepPreview,
    tags: ["Sweep", "Group competition"],
    component: lazy(() => import("./melbourneCupSweep/MelbourneCupSweep"))
  }
];
